import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-shared-plan-explanation-mobile',
  templateUrl: './shared-plan-explanation-mobile.component.html',
  styleUrls: ['./shared-plan-explanation-mobile.component.scss']
})
export class SharedPlanExplanationMobileComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() {
  }

}
